import { initPostHog } from '@shared/lib/posthog'
import { initSentry, initSentryRouter } from '@shared/lib/sentry'
import { QueryClient } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query'
import { routeTree } from '~/routeTree.gen'
import { DefaultCatchBoundary } from '~/shared/ui/DefaultCatchBoundary'
import { NotFound } from '~/shared/ui/NotFound'

// Sentry & PostHog 초기화 — 라우터 생성 전에 실행
initSentry()
initPostHog()

export function getRouter() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60,
      },
    },
  })

  const router = createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    defaultErrorComponent: DefaultCatchBoundary,
    defaultNotFoundComponent: () => <NotFound />,
    scrollRestoration: true,
  })

  setupRouterSsrQueryIntegration({
    router,
    queryClient,
  })

  // Sentry에 TanStack Router 트레이싱 연동
  initSentryRouter(router)

  return router
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
